import { render, staticRenderFns } from "./SacLeaderboard.vue?vue&type=template&id=7b6f70a4&scoped=true"
import script from "./SacLeaderboard.vue?vue&type=script&lang=js"
export * from "./SacLeaderboard.vue?vue&type=script&lang=js"
import style0 from "./SacLeaderboard.vue?vue&type=style&index=0&id=7b6f70a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6f70a4",
  null
  
)

export default component.exports